import en from './en';
import ja from './ja';
import ko from './ko';
import zh from './zh';
import zt from './zt';

export type CountryDict = Record<string, string>;

export const COUNTRY_NAMES: Record<string, CountryDict> = {
  en,
  ja,
  ko,
  zh,
  zt
};
